import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./tabs/tabs.module').then((m) => m.TabsPageModule),
  },
  {
    path: 'safety-rules',
    loadChildren: () =>
      import('./safety-rule/safety-rule.module').then(
        (m) => m.SafetyRulePageModule
      ),
  },
  {
    path: 'sign-on-board',
    loadChildren: () =>
      import('./sign-on-board/sign-on-board.module').then(
        (m) => m.SignOnBoardPageModule
      ),
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
